import { render, staticRenderFns } from "./RaffleProducts.vue?vue&type=template&id=1a89eb4a"
import script from "./RaffleProducts.vue?vue&type=script&lang=js"
export * from "./RaffleProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports